export const highlight = (element, value) => {
    const pattern = new RegExp(`(${RegExp.escape(value)})`, 'gi');

    element.innerHTML = element.textContent.replaceAll(pattern, `<span>$1</span>`);
};
